import { useEffect, useState } from "react";
import api, { fmtDT, fmtDate } from "@/lib/api";
import { PageHeader, StatusBadge, Loading, EmptyState } from "@/components/Shared";
import { ClipboardList, ChevronDown, ChevronUp } from "lucide-react";
import { DeliveryBadge, DeliveryTimeline } from "@/components/DeliveryStatus";

export default function Orders() {
  const [orders, setOrders] = useState(null);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/participations/me").then((r) => setOrders(r.data)).catch(() => setOrders([]));
  }, []);

  if (orders === null) return <Loading />;

  return (
    <div>
      <PageHeader title="Mes commandes" subtitle="Historique de vos participations aux achats groupés." />
      {orders.length === 0 ? (
        <EmptyState title="Aucune commande" subtitle="Participez à une opération pour voir vos commandes ici." icon={ClipboardList} />
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-testid={`order-${o.id}`}>
              <button onClick={() => setOpen(open === o.id ? null : o.id)} className="w-full px-5 py-4 flex items-center gap-4 text-left hover:bg-slate-50 transition-colors duration-200">
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-slate-900 line-clamp-1">{o.operation_name}</div>
                  <div className="text-xs text-slate-400 mt-0.5">{o.supplier_name} · {fmtDate(o.created_at)} · {o.items?.length} articles</div>
                  {o.grossiste_name && <div className="text-xs font-semibold text-indigo-600 mt-0.5">Livraison : {o.grossiste_name}{o.grossiste_city ? ` (${o.grossiste_city})` : ""}</div>}
                </div>
                <DeliveryBadge status={o.delivery_status} />
                <div className="num font-extrabold text-indigo-600 text-lg">{fmtDT(o.total_amount)}</div>
                {open === o.id ? <ChevronUp className="h-4 w-4 text-slate-400" /> : <ChevronDown className="h-4 w-4 text-slate-400" />}
              </button>
              {open === o.id && (
                <div className="border-t border-slate-100">
                  <div className="px-5 py-3 bg-slate-50">
                    <div className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-1">Suivi de livraison</div>
                    <DeliveryTimeline history={o.delivery_history} />
                  </div>
                  <div className="divide-y divide-slate-50">
                    {o.items?.map((it, i) => (
                      <div key={i} className="px-5 py-2.5 flex items-center justify-between text-sm">
                        <span className="font-medium text-slate-700">{it.name}</span>
                        <span className="text-slate-400 num">{it.qty} × {fmtDT(it.unit_price)} = <span className="font-bold text-slate-900">{fmtDT(it.total)}</span></span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
